import { Env } from "./types";
var development = {
    environment: Env.DEVELOPMENT,
    userApiBaseUrl: "http://localhost:3002/api/user/",
    socketServerUrl: "http://localhost:3005/",
    conversationApiBaseUrl: "http://localhost:3002/api/conversations/",
    socketServerApiUri: "http://localhost:3007/api/user",
};
export default development;
